import React, { useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Grid, Tabs, Tab, Alert } from '@nextiva/next-ui-components';
import { useLocation } from 'react-router-dom';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { TabPanel } from 'components';
import { Page } from 'containers';
import { useStateWithLocalStorage } from 'utils/state-helpers';
import { VOICE_ADMIN_DISABLE_DUETO_BWPATCHING } from 'constants/messageText';
import { isAdminAndVoiceUser } from 'utils/user-identifier';
import { useGetInfo } from 'hooks/infoService';
import CompanyInfo from './CompanyInfo';
import Locations from './Locations';

function useQueryParams() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const AccountInfo = () => {
  const {
    featureState: { authV3Enabled, isClusterIdInBWPatching },
  } = useContext(FeatureContext);
  const { data: user } = useGetInfo();
  const query = useQueryParams('account');

  const { data: isVoiceAccount } = useQuery(
    'isVoiceAccount',
    isAdminAndVoiceUser,
  );

  const primaryIdentifier = authV3Enabled
    ? Boolean(user?.profileDTO?.nextOSIdent?.primaryIdentifier)
    : Boolean(user?.profiles?.idents?.nextOS?.primary_identifier);

  const index = query.get('tabIndex');

  const [tabIndex, setTabIndex] = useStateWithLocalStorage(
    'accountInfoTabIndex',
    index ? parseInt(index, 10) : 0,
  );

  const handleTabChange = (_event, newValue) => {
    setTabIndex(newValue);
  };

  useEffect(() => {
    localStorage.setItem('accountInfoTabIndex', '0');
  }, []);

  return (
    <Page title="Account Information" isTabs>
      {isClusterIdInBWPatching && (isVoiceAccount || primaryIdentifier) && (
        <div className="banner" style={{ marginBottom: 32 }}>
          <Alert severity="info" fullWidth>
            {VOICE_ADMIN_DISABLE_DUETO_BWPATCHING}
          </Alert>
        </div>
      )}
      <Grid className="m-tabs" container>
        <Grid item xs={12}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            data-testid="PlatformAdminUI-AccountInfo-Tabs"
          >
            <Tab
              label="Company Info"
              data-testid="PlatformAdminUI-AccountInfo-CompanyInfo"
            />
            <Tab
              label="Locations"
              data-testid="PlatformAdminUI-AccountInfo-Locations"
            />
          </Tabs>
        </Grid>
        <Grid item xs={12}>
          <TabPanel className="test" value={tabIndex} index={0}>
            <CompanyInfo />
          </TabPanel>
          <TabPanel value={tabIndex} index={1} className="locations">
            <Locations />
          </TabPanel>
        </Grid>
      </Grid>
    </Page>
  );
};

export default AccountInfo;
